
import { Vue, Component } from "vue-property-decorator";
import { formatAmount } from "@/utils/Common";

@Component({ methods: { formatAmount } })
export default class FeeStandard extends Vue {

  get feeIntroData() {
    return [
      { name: "（一）申请费", isTitle: true, span: true },
      { name: "1.发明专利", amount: 900 },
      { name: "2.实用新型专利", amount: 500 },
      { name: "3.外观设计专利", amount: 500 },
      { name: "（二）申请附加费", isTitle: true, span: true },
      { name: "1.权利要求附加费从第11项起每项加收", amount: 150 },
      { name: "2.说明书附加费从第31页起每页加收", amount: 50 },
      { name: "从第301页起每页加收", amount: 100 },
      { name: "（三）公布印刷费", isTitle: true, amount: 50 },
      { name: "（四）优先权要求费（每项）", isTitle: true, amount: 80 },
      { name: "（五）发明专利申请实质审查费", isTitle: true, amount: 2500 },
      { name: "（六）复审费", isTitle: true, span: true },
      { name: "（六）复审费", isTitle: true, span: true },
      { name: "1.发明专利", amount: 1000 },
      { name: "2.实用新型专利", amount: 300 },
      { name: "3.外观设计专利", amount: 300 },
      { name: "（七）年费", isTitle: true, span: true },
      { name: "1.发明专利", span: true },
      { name: "1-3 年（每年）", amount: 900 },
      { name: "4-6 年（每年）", amount: 1200 },
      { name: "7-9 年（每年）", amount: 2000 },
      { name: "10-12 年（每年）", amount: 4000 },
      { name: "13-15 年（每年）", amount: 6000 },
      { name: "16-20 年（每年）", amount: 8000 },
      { name: "2.实用新型专利、外观设计专利", span: true },
      { name: "1-3 年（每年）", amount: 600 },
      { name: "4-5 年（每年）", amount: 900 },
      { name: "6-8 年（每年）", amount: 1200 },
      { name: "9-10 年（每年）", amount: 2000 },
      { name: "（八）年费滞纳金", isTitle: true, span: true },
      { name: "每超过规定的缴费时间 1 个月，加收当年全额年费的 5%", span: true },
      { name: "（九）恢复权利请求费", isTitle: true, amount: 1000 },
      { name: "（十）延长期限请求费", isTitle: true, span: true },
      { name: "1.第一次延长期限请求费（每月）", amount: 300 },
      { name: "2.再次延长期限请求费（每月）", amount: 2000 },
      { name: "（十一）著录事项变更费", isTitle: true, amount: 1000 },
      { name: "1.发明人、申请人、专利权人的变更", amount: 200 },
      { name: "（十二）专利权评价报告请求费", isTitle: true, span: true },
      { name: "1.实用新型专利", amount: 2400 },
      { name: "2.外观设计专利", amount: 2400 },
      { name: "（十三）无效宣告请求费", isTitle: true, span: true },
      { name: "1.发明专利权", amount: 3000 },
      { name: "2.实用新型专利权", amount: 1500 },
      { name: "3.外观设计专利权", amount: 1500 },
      { name: "（十四）专利文件副本证明费（每份）", isTitle: true, amount: 30 }
    ];
  }

  formatAmountCol(row: any) {
    return formatAmount(row.amount ?? 0);
  }

  spanMethod(config: any) {
    if (config.row.span) {
      return config.columnIndex === 0 ? [1, 2] : [0, 0];
    }
    return [1, 1];
  }

  cellClsName({ row, columnIndex }: any) {
    if (row.isTitle && columnIndex === 0) {
      return "title-cell";
    }
    return "";
  }
}
